import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../config';

const MANCA_LBL = {
  telefono: 'telefono',
  partita_iva: 'P.IVA',
  ragione_sociale: 'ragione sociale',
  indirizzo: 'indirizzo',
};
const fmtData = (at) => (at ? new Date(at).toLocaleString('it-IT', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—');
const inp = { width: '100%', padding: '5px 7px', border: '1px solid var(--line)', borderRadius: 6, fontSize: 12.5, boxSizing: 'border-box' };
const lbl = { fontSize: 10.5, color: 'var(--faint)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: .3, marginBottom: 2 };

function Riga({ d, onChanged, onRemoved }) {
  const [f, setF] = useState({
    telefono: d.telefono || '', partita_iva: d.partita_iva || '', ragione_sociale: d.ragione_sociale || '',
    comune: d.comune || '', via: d.via || '', civico: d.civico || '',
  });
  const [busy, setBusy] = useState(false);
  const [searching, setSearching] = useState(false);
  const manc = d.campi_mancanti || [];
  const completo = manc.length === 0;
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));

  const salva = async () => {
    setBusy(true);
    try {
      const r = await axios.patch(`${API}/vicine-completare/${d.id}`, f);
      onChanged(r.data.item); toast.success('Salvato');
    } catch (e) { toast.error(e.response?.data?.detail || 'Errore'); } finally { setBusy(false); }
  };
  const ricerca = async () => {
    setBusy(true); setSearching(true);
    try {
      const r = await axios.post(`${API}/vicine-completare/${d.id}/ricerca`);
      const t = r.data.trovati || [];
      onChanged(r.data.item);
      toast[t.length ? 'success' : 'info'](t.length ? `Trovati: ${t.map(x => MANCA_LBL[x] || x).join(', ')}` : 'Niente di nuovo dal sito');
    } catch (e) { toast.error(e.response?.data?.detail || 'Errore'); } finally { setBusy(false); setSearching(false); }
  };
  const promuovi = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/vicine-completare/${d.id}/promuovi`);
      onRemoved(d.id); toast.success(r.data.gia ? 'Era già in archivio — tolta dal contenitore' : 'Promossa in archivio ✓');
    } catch (e) { toast.error(e.response?.data?.detail || 'Errore'); setBusy(false); }
  };
  const rimuovi = async () => {
    if (!window.confirm(`Rimuovere "${d.nome || d.ragione_sociale || 'azienda'}" dal contenitore?`)) return;
    try { await axios.delete(`${API}/vicine-completare/${d.id}`); onRemoved(d.id); } catch { toast.error('Errore'); }
  };

  return (
    <div style={{ background: 'var(--surface)', border: '1px solid var(--line)', borderRadius: 12, padding: 14, marginBottom: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
        <b style={{ fontSize: 14 }}>{d.nome || d.ragione_sociale || '—'}</b>
        {d.categoria && <span style={{ color: 'var(--faint)', fontSize: 12 }}>{d.categoria}</span>}
        {d.sito && <a href={/^https?:\/\//i.test(d.sito) ? d.sito : `https://${d.sito}`} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: 'var(--info)' }}>{String(d.sito).replace(/^https?:\/\//i, '').replace(/\/$/, '')}</a>}
        <div style={{ flex: 1 }} />
        {completo
          ? <span style={{ background: '#dcfce7', color: 'var(--ok)', borderRadius: 999, padding: '2px 10px', fontSize: 11, fontWeight: 700 }}>completa</span>
          : manc.map((m) => <span key={m} style={{ background: 'var(--surface-2)', color: 'var(--warn)', borderRadius: 6, padding: '2px 7px', fontSize: 11, fontWeight: 700 }}>manca: {MANCA_LBL[m] || m}</span>)}
      </div>
      {d.indirizzo_google && <div style={{ fontSize: 11.5, color: 'var(--faint)', marginBottom: 8 }}>Google: {d.indirizzo_google}</div>}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10, marginBottom: 10 }}>
        <div><div style={lbl}>Telefono fisso</div><input style={inp} value={f.telefono} onChange={set('telefono')} placeholder="0xx…" /></div>
        <div><div style={lbl}>P.IVA</div><input style={inp} value={f.partita_iva} onChange={set('partita_iva')} placeholder="11 cifre" /></div>
        <div><div style={lbl}>Ragione sociale</div><input style={inp} value={f.ragione_sociale} onChange={set('ragione_sociale')} /></div>
        <div><div style={lbl}>Comune</div><input style={inp} value={f.comune} onChange={set('comune')} /></div>
        <div><div style={lbl}>Via</div><input style={inp} value={f.via} onChange={set('via')} /></div>
        <div><div style={lbl}>Civico</div><input style={inp} value={f.civico} onChange={set('civico')} /></div>
      </div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
        <button className="btn btn-sm" onClick={salva} disabled={busy}>Salva</button>
        {d.sito && (
          <button className="btn btn-sm" onClick={ricerca} disabled={busy}
            style={{ position: 'relative', overflow: 'hidden', minWidth: 142, justifyContent: 'center' }}>
            {searching ? (
              <>
                <span className="spin" style={{ display: 'inline-flex' }}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><path d="M21 12a9 9 0 1 1-6.2-8.6" /></svg>
                </span>
                Cerco dal sito…
                <span className="vc-prog" />
              </>
            ) : 'Ri-cerca dal sito'}
          </button>
        )}
        <button className="btn btn-sm btn-primary" onClick={promuovi} disabled={busy || !completo} title={completo ? 'Crea il cliente in archivio' : 'Completa prima tutti i campi'}>Promuovi in archivio</button>
        <div style={{ flex: 1 }} />
        <span style={{ fontSize: 11, color: 'var(--line)' }}>agg. {fmtData(d.updated_at)}</span>
        <button className="btn btn-sm" onClick={rimuovi} style={{ color: 'var(--err)' }}>Rimuovi</button>
      </div>
    </div>
  );
}

export default function AziendeCompletarePage() {
  const [items, setItems] = useState([]);
  const [totale, setTotale] = useState(0);
  const [loading, setLoading] = useState(true);

  const carica = useCallback(() => {
    setLoading(true);
    axios.get(`${API}/vicine-completare`).then((r) => {
      setItems(r.data?.items || []); setTotale(r.data?.totale || 0); setLoading(false);
    }).catch(() => setLoading(false));
  }, []);
  useEffect(() => { carica(); }, [carica]);

  const onChanged = (item) => setItems((xs) => xs.map((x) => (x.id === item.id ? item : x)));
  const onRemoved = (id) => { setItems((xs) => xs.filter((x) => x.id !== id)); setTotale((t) => Math.max(0, t - 1)); };

  return (
    <div style={{ padding: 20, maxWidth: 1200 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 6, flexWrap: 'wrap' }}>
        <h2 style={{ margin: 0, fontSize: 20 }}>Aziende da completare</h2>
        <span style={{ background: 'var(--surface-2)', color: 'var(--warn)', borderRadius: 999, padding: '3px 11px', fontSize: 13, fontWeight: 700 }}>{totale}</span>
        <div style={{ flex: 1 }} />
        <button className="btn btn-sm" onClick={carica}>Ricarica</button>
      </div>
      <p style={{ margin: '0 0 14px', color: 'var(--muted)', fontSize: 13 }}>
        Aziende trovate col "Vicine" a cui mancava qualcosa (telefono fisso, P.IVA, ragione sociale o indirizzo completo),
        quindi <b>non</b> entrate in archivio. Completa i campi a mano oppure prova <b>"Ri-cerca dal sito"</b>; quando l'anagrafica
        è completa premi <b>"Promuovi in archivio"</b> per creare il cliente (fonte: Vicine).
      </p>
      {loading ? (
        <div style={{ color: 'var(--faint)', fontSize: 14, padding: 20 }}>Carico…</div>
      ) : items.length === 0 ? (
        <div style={{ color: 'var(--ok)', fontSize: 14, padding: 20, background: 'var(--surface-2)', border: '1px solid var(--surface-2)', borderRadius: 12 }}>
          Nessuna azienda da completare. 🎉
        </div>
      ) : (
        items.map((d) => <Riga key={d.id} d={d} onChanged={onChanged} onRemoved={onRemoved} />)
      )}
    </div>
  );
}
